import { useCallback, useState } from 'react';
import { DEFAULT_NATIONALITY } from '../constants/options';
import { maskRg } from '../utils/masks';

export const EMPTY_CANDIDATE = {
    name: '',
    birth_date: '',
    rg: '',
    rg_emission: '',
    rg_state: '',
    emission_date_rg: '',
    nationality: DEFAULT_NATIONALITY,
    gender: '',
    civil_state: '',
    address: { zip_code: '', street: '', number: '', complement: '', neighborhood: '', city: '', state: '' },
    phone_contact: '',
    email: '',
    social_name: null,
    special_conditions: null,
    pcd: null,
    schooling: '',
    courses: '',
    experience: ''
};

/**
 * Normalizes a candidate coming from the API into form values.
 */
export const candidateToFormValues = (candidate) => {
    if (!candidate) return { ...EMPTY_CANDIDATE };
    return {
        ...EMPTY_CANDIDATE,
        ...candidate,
        rg: candidate.rg ? maskRg(candidate.rg) : '',
        birth_date: candidate.birth_date ? String(candidate.birth_date).substring(0, 10) : '',
        emission_date_rg: candidate.emission_date_rg ? String(candidate.emission_date_rg).substring(0, 10) : '',
        address: { ...EMPTY_CANDIDATE.address, ...(candidate.address || {}) },
        courses: candidate.courses || '',
        experience: candidate.experience || ''
    };
};

/**
 * Form state with support for "address.<field>" names and server-side errors.
 */
export const useCandidateForm = (initial = EMPTY_CANDIDATE) => {
    const [values, setValues] = useState(initial);
    const [errors, setErrors] = useState({});

    const setField = useCallback((name, value) => {
        setValues((current) => {
            if (name.startsWith('address.')) {
                const field = name.split('.')[1];
                return { ...current, address: { ...current.address, [field]: value } };
            }
            return { ...current, [name]: value };
        });
        setErrors((current) => {
            if (!current[name]) return current;
            const next = { ...current };
            delete next[name];
            return next;
        });
    }, []);

    return { values, setValues, errors, setErrors, setField };
};
